import { render } from "./ContractsTab.vue?vue&type=template&id=0559f2ff&scoped=true"
import script from "./ContractsTab.vue?vue&type=script&lang=js"
export * from "./ContractsTab.vue?vue&type=script&lang=js"

import "./ContractsTab.vue?vue&type=style&index=0&id=0559f2ff&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0559f2ff"]])

export default __exports__